/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ArrowsRepeatRegularV6 = (props) => (
  <Icon {...props} name="Arrows Repeat Regular V6">
    <path d="M15.25 7.25a.75.75 0 0 0-.75.75 3.254 3.254 0 0 1-3.25 3.25H4.559l1.97-1.97a.75.75 0 1 0-1.061-1.061l-3.25 3.25a.75.75 0 0 0 0 1.061l3.25 3.25c.147.148.338.22.532.22s.384-.073.53-.22a.75.75 0 0 0 0-1.061l-1.971-1.97h6.691A4.756 4.756 0 0 0 16 7.999a.748.748 0 0 0-.75-.75zm-10.5-2.5h6.691l-1.97 1.97a.75.75 0 0 0 1.059 1.061l3.25-3.25a.75.75 0 0 0 0-1.061L10.53.22a.75.75 0 1 0-1.061 1.061l1.971 1.97H4.749c-2.619 0-4.75 2.131-4.75 4.722 0 .441.336.778.75.778s.75-.334.75-.75a3.254 3.254 0 0 1 3.25-3.25z" />
  </Icon>
);

export default ArrowsRepeatRegularV6;
